import type { IToolsModule } from '../types';

const ToolsModule: IToolsModule  = {

    focusVisibleContent(): void {
        const elements = document.querySelectorAll('.tab-content-right');

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i] as HTMLElement;

            const parent = element.parentElement;
            if (parent && parent.classList.contains('tab-content-hidden')) {
                continue;
            }

            if (!element.hasAttribute('tabindex')) {
                element.setAttribute('tabindex', '-1');
            }

            element.focus();
            break;
        }
    },

    setLanguageAttribute(lang: string): void {
        document.documentElement.lang = lang;
    },

    setHtmlAttribute(attributeName: string, attributeValue: string): void {
        document.documentElement.setAttribute(attributeName, attributeValue);
    },

    getElementText(element: HTMLElement | null): string {
        return element?.innerText ?? '';
    },

    scrollToTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    getAvailableHeightBelow(element: HTMLElement, minHeight: number, margin: number): number {
        if (!element) return minHeight;

        const rect = element.getBoundingClientRect();
        return Math.round(Math.max(window.innerHeight - rect.bottom - margin, minHeight));
    },
};

export default ToolsModule;
